
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { ModalState } from '@/core/types/modal-state';
import { Alert } from '@/core/types/alert';
import { ProfileFI } from '@/profile/types/profile-fi';
import ProfilePlaidWrapper from '@/profile/components/ProfilePlaidWrapper.vue';
import { Plaid } from '@/core/types/plaid';
import { SessionUser } from '@/core/types/session-user';
import { PlaidSuccess } from '@/core/types/plaid-succes';
import { ProfileAPIService } from '@/profile/services/api';
import { AlertTypeEnum } from '@/core/types/alert-type-enum';
import { AccountType } from '@/core/enums/account-type';
import { CoreHelper } from '@/core/helper';
import ProfileMyProfileAcceptDwollaTermsModal from '@/profile/pages/ProfileMyProfile/ProfileMyProfileAcceptDwollaTermsModal.vue';
import { namespace } from 'vuex-class';

const profileNamespace = namespace('profile');

const PLAID_ACCOUNT_ADDED_SUCCESS_MESSAGE = 'Account Successfully Added.';

@Component({
	components: {
		ProfilePlaidWrapper,
		ProfileMyProfileAcceptDwollaTermsModal,
	},
})
export default class ProfileMyProfileAddLinkedAccountModal extends Vue {
	public acceptDwollaTermsModalState: ModalState = {
		isShown: false,
	};

	public alert: Alert | null = null;

	@Prop({ required: true })
	public accountType!: AccountType;

	@Prop({ default: [] })
	public institutions!: ProfileFI[];

	@Prop({ default: '' })
	public paymentRefUrl!: string;

	public isShown = false;

	@Prop({ required: true })
	public plaid!: Plaid;

	@Prop({ default: { isShown: false } })
	public state!: ModalState;

	@Prop({ required: true })
	public user!: SessionUser;

	@Prop({ default: true })
	public isPlaidShown!: boolean;

	public isAddPlaidAccountLoading = false;

	public wasPlaidAccountAddSuccessful = false;

	public boundPlaidProps: any;

	@profileNamespace.Action('getAndSetAllAccounts')
	public getAndSetAllAccounts!: () => Promise<void>;

	@Watch('state')
	public watchState(state: { isShown: boolean }): void {
		this.isShown = state.isShown;
	}

	@Emit('linkPlaid')
	public emitLinkPlaid(): boolean {
		return true;
	}

	public bindPlaidProps(plaidProps: any): void {
		this.boundPlaidProps = plaidProps;
	}

	public handleAdd(institution: ProfileFI): void {
		this.$router.push({
			name: 'ProfileAddLinkedAccount',
			query: {
				type: this.accountType,
				fid: String(institution.id),
			},
			params: { paymentRefUrl: this.paymentRefUrl },
		});

		this.close();
	}

	public handleAddOther(): void {
		if (!this.user.dwollaTermsAcceptedAt) {
			this.showDwollaTerms();
			return;
		}

		this.showPlaid();
	}

	public handleAcceptDwollaTerms(): void {
		this.showPlaid();
	}

	public close(): void {
		this.isShown = false;
		this.reset();
	}

	public showDwollaTerms(): void {
		this.acceptDwollaTermsModalState = {
			isShown: true,
		};
	}

	public showPlaid(): void {
		this.boundPlaidProps.context.onClick();
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	public onPlaidEvent(): void {}

	public async onPlaidSuccess(success: PlaidSuccess): Promise<void> {
		this.alert = null;
		this.isAddPlaidAccountLoading = true;
		this.wasPlaidAccountAddSuccessful = false;

		try {
			await ProfileAPIService.addLinkedAccounts(success.metaData);
			await this.getAndSetAllAccounts();

			this.wasPlaidAccountAddSuccessful = true;

			this.alert = {
				type: AlertTypeEnum.SUCCESS,
				message: PLAID_ACCOUNT_ADDED_SUCCESS_MESSAGE,
			};

			if (this.paymentRefUrl) {
				window.location.href = this.paymentRefUrl;
			}
		} catch (error) {
			console.error(error);

			this.alert = {
				type: AlertTypeEnum.ERROR,
				message: CoreHelper.getHttpErrorMessage(error),
			};
		}

		this.isAddPlaidAccountLoading = false;
	}

	private reset(): void {
		this.alert = null;
		this.wasPlaidAccountAddSuccessful = false;
	}
}
